import { Fee } from '@/types/skuDataBackend';

export async function getFees(): Promise<Fee | null> {
  try {
    const response = await fetch('/api/fees');
    const json = await response.json();
    return json[0];
  } catch (err) {
    return null;
  }
}
